import NotActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveinitialInfo.svg?react';
import NotActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveContact.svg?react';
import ActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeContact.svg?react';
import ActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeinitialInfo.svg?react';
import { StepType } from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper.type';
import { ADJUSTER_REPORT_BODY_DAMAGE_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
export const bodyOwnerStepsData: StepType[] = [
  {
    label: 'اطلاعات پایه',
    icon: <NotActiveinitialInfo />,
    activeIcon: <ActiveinitialInfo />,
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT.owner,
  },
  {
    label: 'اطلاعات تماس',
    icon: <NotActiveContact />,
    activeIcon: <ActiveContact />,
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.DRIVER_OWNER.EDIT
      .ownerContact,
  },
];
